import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Splide from "@splidejs/splide";

gsap.registerPlugin(ScrollTrigger);

export default class{
    constructor(){
        this.run(document);
    }
    run(d){
        const aboutSlider = d.querySelectorAll('[data-about-slider]');
        if (aboutSlider.length > 0) {
            aboutSlider.forEach(el => {
                const splide = new Splide(el,{
                    autoplay: true,
                    type: 'fade',
                    rewind: true,
                    arrows: false,
                    pagination: false,
                    interval: 5000,
                    speed: 1500,
                    drag: false,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                } ).mount();
            });
        }
    }
}